import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { api, errMsg, fmtDT } from "../lib/api";
import { PageHeader, useLoad, StatusBadge, Empty } from "../components/common";

function SheetUpload({ kind, label, done }) {
  const [busy, setBusy] = useState(false);
  const up = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData(); fd.append("kind", kind); fd.append("file", file);
    try { const r = await api.post("/roster/import", fd); toast.success(`Imported: ${JSON.stringify(r.data).slice(0, 140)}`); done(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <label className="inline-flex items-center h-9 px-4 rounded border bg-white text-sm font-medium cursor-pointer hover:bg-zinc-50 transition-colors">
      {busy ? "Importing…" : label}<input type="file" accept=".csv,.xlsx" className="hidden" onChange={(e) => up(e.target.files[0])} data-testid={`roster-upload-${kind}`} />
    </label>
  );
}

function Item({ it, reload }) {
  const resolve = async (resolution, target_user_id) => {
    try { await api.post(`/review/${it.id}/resolve`, { resolution, target_user_id }); toast.success("Resolved"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <tr data-testid={`review-item-${it.id}`}>
      <td><StatusBadge s="open" label={it.kind.replace(/_/g, " ")} /></td><td className="text-sm">{it.summary}</td><td className="mono text-xs">{fmtDT(it.created_at)}</td>
      <td className="text-right whitespace-nowrap space-x-1">
        {it.kind === "possible_match" && it.details.candidates?.map((c) => (
          <Button key={c.user_id} size="sm" variant="outline" onClick={() => resolve("merge", c.user_id)} data-testid={`review-merge-${it.id}-${c.user_id}`}>Same as {c.name}</Button>))}
        <Button size="sm" variant="outline" onClick={() => resolve(it.kind === "possible_match" ? "keep_separate" : "acknowledged")} data-testid={`review-keep-${it.id}`}>{it.kind === "possible_match" ? "Different people" : "Acknowledge"}</Button>
      </td>
    </tr>
  );
}

export default function ReviewPage() {
  const [data, reload] = useLoad(async () => (await api.get("/review")).data);
  return (
    <div data-testid="review-page" className="space-y-6">
      <PageHeader title="Import & matching review" sub="Staff roster and Entrance account sheets. Nothing is merged without your confirmation.">
        <SheetUpload kind="roster" label='Upload "CIHM STAFF - STAFF.csv"' done={reload} />
        <SheetUpload kind="entrance" label='Upload "Entrance X Select User sheet - Active.csv"' done={reload} />
      </PageHeader>
      <div className="panel overflow-x-auto">
        <div className="p-4 pb-0 font-bold">Open items ({data?.items?.length ?? 0})</div>
        {!data?.items?.length ? <Empty text="No open review items. Upload the two sheets to begin." /> : (
          <table className="dt" data-testid="review-table"><thead><tr><th>Type</th><th>Summary</th><th>Created</th><th /></tr></thead>
            <tbody>{data.items.map((it) => <Item key={it.id} it={it} reload={reload} />)}</tbody></table>)}
      </div>
      <div className="panel overflow-x-auto">
        <div className="p-4 pb-0 font-bold">People with missing or unverified information ({data?.incomplete_people?.length ?? 0})</div>
        <table className="dt" data-testid="incomplete-table"><thead><tr><th>Name</th><th>Role</th><th>Group</th><th>Match</th><th>Missing</th></tr></thead>
          <tbody>{(data?.incomplete_people || []).map((u) => <tr key={u.id}><td className="font-medium">{u.display_name}</td><td>{u.role}</td><td className="text-xs">{u.roster_group || "—"}</td>
            <td className="text-[11px] text-zinc-500">{u.match?.entrance_method || u.match?.method}</td><td className="text-[11px] text-amber-700">{u.missing.join(", ")}</td></tr>)}</tbody></table>
      </div>
    </div>
  );
}
